import CollapsedRow from './CollapsedRow';

export default CollapsedRow;
